import React, { useState } from 'react';
import './Adminlogin.css'
import { Input, Button, Form, Typography, notification, Spin } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'; // Import the success icon


const AdminLogin = (props) => {
  const [adminusername, setAdminusername] = useState('');
  const [adminpassword, setAdminpassword] = useState('');
  const [cnfpassword, setCnfpassword] = useState('');
  // const [loading, setLoading] = useState(false); // State for loading spinner

  const backend_url = process.env.REACT_APP_BACKEND_URL



  const { Title, Text } = Typography;

  const handleSubmit = async (e) => {
    // console.log('props......', props)
    props.setLoad(true); // Set loading to true when the form is submitted

    try {


      if (adminpassword !== cnfpassword) {
        // console.error('password and cnf not match')
        notification.error({
          message: 'Password and Confirm Password not match',
          // description: 'This is the content of the notification.',
          placement: 'topRight',
          duration: 2, // Duration in seconds, 0 means no auto close

          icon: <CloseCircleOutlined style={{ color: 'red' }} />, // Custom icon
        });
        return
      }


      const response = await fetch(`${backend_url}/api/admin-login`, {
      // const response = await fetch(`http://localhost:8000/api/admin-login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ adminusername, adminpassword })
      });


      const res = await response.json()
      console.log('res------->',res)





      if (res.status === 404) {
        notification.error({
          message: 'Admin Not Found',
          // description: 'This is the content of the notification.',
          placement: 'topRight',
          duration: 2, // Duration in seconds, 0 means no auto close

          icon: <CheckCircleOutlined style={{ color: 'green' }} />, // Custom icon
        });

      }




      if (res.status === 200) {
        notification.success({
          message: 'Login Succefully',
          // description: 'This is the content of the notification.',
          placement: 'topRight',
          duration: 2, // Duration in seconds, 0 means no auto close

          icon: <CheckCircleOutlined style={{ color: 'green' }} />, // Custom icon
        });

        localStorage.setItem("admintoken", res.token)


        setAdminusername('')
        setAdminpassword("")
        props.setIsLoggedIn("changed")
      }



    } catch (error) {
      console.error(error);
      notification.error({
        message: `Invalid Credentials`,
        // description: 'This is the content of the notification.',
        placement: 'topRight',
        duration: 2, // Duration in seconds, 0 means no auto close

        icon: <CloseCircleOutlined style={{ color: 'red ' }} />, // Custom icon
      });
    }
    finally {
      props.setLoad(false); // Set loading to false after the login process is complete
    }
  };








  return (





    <>
      <div className='rounded-3xl'>


        <Title level={2} className="text-center mb-6">
          <p className='login-tag'>

            Login
          </p>
        </Title>
        <Form onFinish={handleSubmit} layout="vertical">
          <Form.Item>
            <Input
              type="text"
              placeholder="Username"
              value={adminusername}
              onChange={(e) => setAdminusername(e.target.value)}
              className="rounded-md md:w-[25vw] w-full"
            />
          </Form.Item>
          <Form.Item>
            <Input.Password
              placeholder="Password"
              value={adminpassword}
              onChange={(e) => setAdminpassword(e.target.value)}
              className="rounded-md"
            />
          </Form.Item>
          <Form.Item>
            <Input.Password
              placeholder="Confirm Password"
              value={cnfpassword}
              onChange={(e) => setCnfpassword(e.target.value)}
              className="rounded-md"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full rounded-md"
              disabled={props.loading} // Disable the button when loading
            >
              Login
            </Button>
          </Form.Item>
        </Form>

        <Text className="text-black  transition duration-300">
          Don't have an account?
          <span onClick={props.onFlip} className='cursor-pointer font-black' > Sign up</span>
        </Text>


      </div>
    </>
  );
};

export default AdminLogin;
